module.exports = __webpack_public_path__ + "img/spartan_logo_with_title.bcf61023.svg";